module.exports = __webpack_public_path__ + "static/img/tv-3b.ed3975b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tv-3b.png
// module id = 257
// module chunks = 0